import { MenuGroup } from '../models/application-menu.model';

/**
 * Menu items on the aside menu, will be displayed on `aside.component.ts`.
 * This static menu is used for superadmin only (static, all access).
 * Support up to 3 levels of children.
 */
export const sidebarStaticMenu: MenuGroup[] = [
  {
    name: '',
    global: true,
    groupChildren: [
      {
        name: 'Dashboard',
        link: '/dashboard',
        icon: './assets/media/svg/icons/Periksa/beranda-icon.svg',
        single: true,
      },
    ],
  },
  {
    name: 'Periksa - Monitoring',
    groupChildren: [
      {
        name: 'Monitoring',
        icon: './assets/media/svg/icons/Periksa/dashboard-icon.svg',
        link: '/monitoring',
        children: [
          {
            name: 'Dashboard Antrian Pasien',
            link: '/monitoring/dashboard-antrian-pasien',
          },
          {
            name: 'Dashboard Kedatangan Pasien',
            link: '/monitoring/dashboard-kedatangan-pasien',
          },
          {
            name: 'Dashboard Pasien',
            link: '/monitoring/dashboard-pasien',
          },
          {
            name: 'Dashboard Rawat Inap',
            link: '/monitoring/dashboard-rawat-inap',
          },
          {
            name: 'Dashboard Farmasi',
            link: '/monitoring/dashboard-farmasi',
          },
          {
            name: 'Dashboard Kepegawaian',
            link: '/monitoring/dashboard-kepegawaian',
          },
          {
            name: 'Dashboard Keuangan',
            link: '/monitoring/dashboard-keuangan',
          },
          {
            name: 'Dashboard Pemakaian Sistem',
            link: '/monitoring/dashboard-pemakaian-sistem',
          },
          {
            name: 'Dashboard Inventory',
            link: '/monitoring/dashboard-inventory',
          },
          {
            name: 'Dashboard Laboratorium',
            link: '/monitoring/dashboard-laboratorium',
          },
          {
            name: 'Dashboard Pasien BPJS',
            link: '/monitoring/dashboard-pasien-bpjs',
          },
          {
            name: 'Dashboard Radiologi',
            link: '/monitoring/dashboard-radiologi',
          },
          {
            name: 'Dashboard Penjamin',
            link: '/monitoring/dashboard-penjamin',
          },
          {
            name: 'Dashboard Pusat Kendali Rumah Sakit',
            link: '/monitoring/dashboard-pusat-kendali-rs',
            newTab: true,
          },
          {
            name: 'Dashboard Bed Management',
            link: '/monitoring/dashboard-bed-management',
          },
          {
            name: 'Dashboard UTD',
            link: '/monitoring/dashboard-utd',
          },
        ],
      },
    ],
  },
  {
    name: 'Application',
    groupChildren: [
      {
        name: 'Medical Record',
        icon: './assets/media/svg/icons/Periksa/medical-record-icon.svg',
        link: '/medical-record',
        children: [
          {
            name: 'Pendaftaran Pasien Baru',
            link: '/medical-record/pendaftaran-pasien-baru',
          },
          {
            name: 'Mini Pendaftaran Pasien Baru',
            link: '/medical-record/mini-pendaftaran-pasien-baru',
          },
          {
            name: 'Pendaftaran Pasien Baru Online',
            link: '/medical-record/pendaftaran-pasien-baru-online',
          },
          {
            name: 'Pasien',
            link: '/medical-record/manage-pasien',
          },
          {
            name: 'Pasien Lansia',
            link: '/medical-record/suggest-pasien-lansia',
          },
          {
            name: 'Jadwal Dokter',
            link: '/medical-record/jadwal-dokter',
          },
          {
            name: 'Non Pasien',
            link: '/medical-record/non-pasien',
          },
          {
            name: 'Koding ICD',
            link: '/medical-record/koding-icd',
          },
          {
            name: 'Tracer Pasien',
            link: '/medical-record/tracer-pasien',
          },
          {
            name: 'Petugas Rekam Medis',
            link: '/medical-record/tracer-pasien-porter',
          },
          {
            name: 'Pindah Rekam Medis',
            link: '/medical-record/pindah-rekam-medis',
          },
          {
            name: 'Data Bayi',
            link: '/medical-record/data-bayi',
          },
          {
            name: 'Janji Kunjungan Pasien',
            link: '/medical-record/janji-kunjungan',
          },
          {
            name: 'Pendaftaran Rawat Inap',
            link: '/medical-record/manage-pendaftaran-rawat-inap',
          },
          {
            name: 'Informasi Tempat Tidur',
            link: '/medical-record/informasi-tempat-tidur',
          },
          {
            name: 'Manage Tempat Tidur',
            link: '/medical-record/manage-tempat-tidur',
          },
          {
            name: 'Manage Surat Pasien Pulang',
            link: '/medical-record/manage-surat-pasien-pulang',
          },
          {
            name: 'Manage Jadwal Janji Operasi',
            link: '/medical-record/jadwal-janji-operasi',
          },
          {
            name: 'Manage Swab',
            link: '/medical-record/manage-covid-test',
          },
          {
            name: 'Manage Vaksin',
            link: '/medical-record/manage-vaccination',
          },
          {
            name: 'Manage Akta Kelahiran',
            link: '/medical-record/manage-akta-kelahiran',
          },
          {
            name: 'Manage Ringkasan Pulang Rawat Jalan',
            link: '/medical-record/manage-ringkasan-pulang-rawat-jalan',
          },
          {
            name: 'Manage Verifikasi',
            link: '/medical-record/manage-verifikasi-rajal-ranap',
          },
          {
            name: 'Manage Pasien HIV',
            link: '/medical-record/manage-pasien-hiv',
          },
          {
            name: 'Pasien Non Aktif',
            link: '/medical-record/manage-pasien-non-aktif',
          },
          {
            name: 'Skrining Awal Pasien',
            link: '/medical-record/skrining-awal-pasien',
          },
          {
            name: 'Skrining Awal Pasien IGD',
            link: '/medical-record/skrining-awal-pasien-igd',
          },
          {
            name: 'Manage Transfer Pasien Head Office',
            link: '/medical-record/group-faskes/manage-transfer-pasien-headoffice',
          },
          {
            name: 'Manage Cetak Pasien',
            link: '/medical-record/manage-cetak-pasien',
          },
          {
            name: 'Dental Home Care Services',
            link: '/medical-record/approval-janji-temu',
          },
          {
            name: 'Reminder Pasien',
            link: '/medical-record/reminder-pasien',
          },
        ],
      },
      {
        name: 'Kasir',
        icon: './assets/media/svg/icons/Periksa/kasir-icon.svg',
        link: '/kasir',
        children: [
          {
            name: 'Point of Sales',
            link: '/kasir/point-of-sales',
          },
          {
            name: 'Point of Sales V2',
            link: '/kasir/point-of-sales-v2',
          },
          {
            name: 'Cashier Receipt Form',
            link: '/kasir/cashier-receipt-form',
          },
          {
            name: 'Antrian Kasir Rawat Inap',
            link: '/kasir/antrian-kasir-ranap',
          },
          {
            name: 'Antrian Kasir Rawat Jalan Parsial',
            link: '/kasir/antrian-kasir-umum-parsial',
          },
          {
            name: 'Manage Cetak Kwitansi Rawat Jalan',
            link: '/kasir/manage-cetak-kwitansi/umum',
          },
          {
            name: 'Manage Cetak Kwitansi Rawat Inap',
            link: '/kasir/manage-cetak-kwitansi/ranap',
          },
          {
            name: 'Manage Batal Kwitansi',
            link: '/kasir/manage-batal-kasir',
          },
          {
            name: 'Manage Retur Kwitansi',
            link: '/kasir/manage-retur-kwitansi',
          },
          {
            name: 'Manage Uang Muka',
            link: '/kasir/manage-uang-muka',
          },

          {
            name: 'Manage Piutang Pasien',
            link: '/kasir/manage-piutang-pasien',
          },
          {
            name: 'Manage Piutang Pegawai',
            link: '/kasir/manage-piutang-pegawai',
          },
          { name: 'Manage Cetak Kasir Pasien Online', link: '/kasir/manage-cetak-kasir-online' },
          {
            name: 'Manage Perkiraan Layanan Pasien',
            link: '/kasir/manage-perkiraan-layanan-pasien',
          },
        ],
      },
      {
        name: 'Farmasi',
        icon: './assets/media/svg/icons/Periksa/farmasi-icon.svg',
        link: '/farmasi',
        children: [
          {
            name: 'Tulis Resep Digital',
            link: '/farmasi/tulis-resep-digital/0',
          },
          {
            name: 'Antrian Resep Pasien',
            link: '/farmasi/antrian-resep-pasien/0',
          },
          {
            name: 'Riwayat Resep Digital',
            link: '/farmasi/riwayat-resep-digital/0',
          },
          {
            name: 'Riwayat Potong Stock',
            link: '/farmasi/riwayat-resep-digital/potong-stock',
          },
          {
            name: 'Manage Retur Resep',
            link: '/farmasi/manage-retur-resep',
          },
          {
            name: 'Manage Verifikasi Retur Resep',
            link: '/farmasi/manage-retur-resep-verifikasi',
          },
          {
            name: 'Manage Pemberian Obat',
            link: '/farmasi/manage-pemberian-obat',
          },
          {
            name: 'Manage Pemberian Obat Pasien IGD',
            link: '/farmasi/manage-pemberian-obat-pasien-igd',
          },
          {
            name: 'Manage Resep Iter',
            link: '/farmasi/iter-resep',
          },
          {
            name: 'Verifikasi Resep Farmasi & Perawat',
            link: '/farmasi/manage-verifikasi-resep-farmasi-perawat',
          },
          {
            name: 'Riwayat Hapus Resep',
            link: '/farmasi/riwayat-hapus-resep',
          },
        ],
      },
      {
        name: 'Gizi',
        icon: './assets/media/svg/icons/Periksa/gizi-icon.svg',
        link: '/gizi',
        children: [
          {
            name: 'Gizi Pasien',
            link: '/gizi/gizi-pasien',
          },
          {
            name: 'Distribusi Makanan',
            link: '/gizi/distribusi-makanan',
          },
          {
            name: 'Manage Pemesanan Diet Khusus',
            link: '/master-gizi/manage-pemesanan-diet-khusus',
          },
          {
            name: 'Laporan Distribusi Barang Gizi',
            link: '/laporan/laporan-distribusi-barang-gizi',
          },
        ],
      },
      {
        name: 'Laundry',
        icon: './assets/media/svg/icons/Periksa/laundry-icon.svg',
        link: '/laundry',
        children: [
          {
            name: 'Laundry',
            link: '/laundry',
          },
        ],
      },
    ],
  },
  {
    name: 'Periksa - Medis',
    groupChildren: [
      {
        name: 'Medis',
        icon: './assets/media/svg/icons/Periksa/medis-icon.svg',
        link: '/medis',
        children: [
          {
            name: 'Antrian Medis',
            link: '/medis/antrian-pasien',
          },
          {
            name: 'Manage Permintaan Bahan',
            link: '/medis/manage-permintaan-bahan',
          },
          {
            name: 'Manage Data Formulir Medis',
            link: '/medis/manage-data-form-medis',
          },
          {
            name: 'Manage Data Surat Keterangan',
            link: '/medis/manage-data-surat-keterangan',
          },
          {
            name: 'Konfirmasi Konsultasi Pasien',
            link: '/medis/konfirmasi-konsultasi-pasien',
          },
          {
            name: 'Manage PPK',
            link: '/medis/manage-ppk',
          },
          {
            name: 'Manage CSSD',
            link: '/laporan/laporan-cssd',
          },
          {
            name: 'Manage Lab Tekniker Gigi',
            link: '/medis/manage-lab-tekniker-gigi',
          },
        ],
      },
      {
        name: 'Surat Medis',
        icon: './assets/media/svg/icons/Periksa/medis-icon.svg',
        link: '/medis',
        children: [
          {
            name: 'Manage Rujuk Klinik External',
            link: '/medis/manage-rujuk-klinik-external',
          },
          {
            name: 'Surat Sehat',
            link: '/medis/surat-sehat',
          },
          {
            name: 'Surat Sakit',
            link: '/medis/surat-sakit',
          },
          {
            name: 'Surat Keterangan Lahir',
            link: '/medis/surat-keterangan-lahir',
          },
          {
            name: 'Manage Surat Bebas Narkoba',
            link: '/medis/surat-bebas-narkoba',
          },
          {
            name: 'Manage Surat Keterangan Kesehatan Jiwa',
            link: '/medis/surat-keterangan-kesehatan-jiwa',
          },
          {
            name: 'Manage Surat Keterangan Pemeriksaan mata',
            link: '/medis/surat-keterangan-pemeriksaan-mata',
          },
          {
            name: 'Manage Surat Keterangan Kematian',
            link: '/medis/surat-kematian',
          },
          {
            name: 'Manage Surat Keterangan Opname',
            link: '/medis/surat-keterangan-opname',
          },
          {
            name: 'Manage Surat Keterangan Istirahat',
            link: '/medis/surat-keterangan-istirahat',
          },
          {
            name: 'Manage Surat Pernyataan Kronologi',
            link: '/medis/surat-pernyataan-kronologi',
          },
        ],
      },
      {
        name: 'Rawat Inap',
        icon: './assets/media/svg/icons/Periksa/medis-icon.svg',
        link: '/rawat-inap',
        children: [
          {
            name: 'Status Hunian Kamar',
            link: '/rawat-inap/antrian-pasien-rawat-inap',
          },
          {
            name: 'Plasma Ketersediaan Tempat Tidur',
            newTab: true,
            link: '/plasma-ketersediaan-tempat-tidur/display',
          },
          {
            name: 'Monitor Ketersediaan Tempat Tidur',
            newTab: true,
            link: '/plasma-ketersediaan-tempat-tidur/monitor-tempat-tidur',
          },
          {
            name: 'TV Display Ketersediaan Kamar Berdasarkan Jenis Kelamin',
            newTab: true,
            link: '/plasma-ketersediaan-tempat-tidur/monitor-tempat-tidur-jk',
          },
        ],
      },
      {
        name: 'Unit Transfusi Darah (UTD)',
        icon: './assets/media/svg/icons/Periksa/medis-icon.svg',
        link: '/rawat-inap',
        children: [
          {
            name: 'Ketersediaan Darah',
            link: '/master-medis/ketersediaan-darah',
          },
          {
            name: 'Manage Donor Darah',
            link: '/medis/manage-donor-darah',
          },
          {
            name: 'Manage Darah Masuk',
            link: '/medis/manage-darah-masuk',
          },
          {
            name: 'Manage Permintaan Darah',
            link: '/medis/manage-darah-keluar',
          },
          {
            name: 'Pemeriksaan Uji Cocok Serasi',
            link: '/medis/manage-darah-crossmatching',
          },
          {
            name: 'Manage Verifikasi Permintaan Darah',
            link: '/medis/verifikasi-darah-keluar',
          },
        ],
      },
    ],
  },
  {
    name: 'Periksa - Keuangan',
    groupChildren: [
      {
        name: 'Keuangan',
        icon: './assets/media/svg/icons/Periksa/keuangan-icon.svg',
        link: '/keuangan',
        children: [
          {
            name: 'Manage Tindakan',
            link: '/keuangan/manage-tindakan',
          },
          {
            name: 'Manage Tindakan Online',
            link: '/keuangan/manage-tindakan-online',
          },
          {
            name: 'Manage Tarif Tindakan',
            link: '/keuangan/manage-tarif-tindakan',
          },
          {
            name: 'Manage Tindakan Kelompok',
            link: '/keuangan/manage-kelompok-per-bulan',
          },
          {
            name: 'Manage Jasa Pelayanan Berdasarkan Transaksi',
            link: '/keuangan/manage-jasa-pelayanan-berdasarkan-transaksi',
          },
          {
            name: 'Manage Sharing Fee',
            link: '/keuangan/manage-sharing-fee',
          },
          {
            name: 'Manage Sharing Fee Product',
            link: '/keuangan/manage-sharing-fee-product',
          },
          {
            name: 'Manage Pembayaran O/P Jasa Tenaga medis',
            link: '/keuangan/manage-pembayaran-op',
          },
          {
            name: 'Manage Asset Management',
            link: '/keuangan/manage-asset-management',
          },
          {
            name: 'Manage Pengeluaran',
            link: '/keuangan/manage-expense',
          },
          {
            name: 'Manage Paket Tindakan',
            link: '/keuangan/manage-paket-tindakan',
          },
          {
            name: 'Manage Pemasukan',
            link: '/keuangan/manage-pemasukan-ar',
          },
          {
            name: 'Manage Pembayaran A/P',
            link: '/keuangan/manage-pengeluaran-ap',
          },
          {
            name: 'Manage RAB',
            link: '/keuangan/manage-rab',
          },
          {
            name: 'Manage Tindakan Non Aktif',
            link: '/keuangan/manage-tindakan-nonaktif',
          },
          {
            name: 'Manage Pembayaran Asuransi ',
            link: '/keuangan/manage-pembayaran-asuransi',
          },
          // {
          //   name: 'SCF BNI',
          //   link: '/keuangan/scf-bnii',
          // },
          {
            name: 'Manage Tindakan INACBG ',
            link: '/keuangan/manage-tindakan-inacbg',
          },
          {
            name: 'Dashboard Pembayaran Online',
            link: '/keuangan/ewallet-dashboard',
          },
          {
            name: 'Manage Pembayaran Virtual Account',
            link: '/keuangan/manage-virtual-account',
          },
          {
            name: 'Manage Indikator Fee Dokter',
            link: '/keuangan/manage-indikator-fee-dokter',
          },
        ],
      },
      {
        name: 'E-Wallet',
        icon: './assets/media/svg/icons/Periksa/e_wallet-icon.svg',
        link: '/keuangan',
        children: [
          {
            name: 'Dashboard Pembayaran Online',
            link: '/keuangan/ewallet-dashboard',
          },
          {
            name: 'Manage Pembayaran Virtual Account',
            link: '/keuangan/manage-virtual-account',
          },
        ],
      },
      {
        name: 'Jurnal',
        icon: './assets/media/svg/icons/Periksa/keuangan-icon.svg',
        link: '/keuangan',
        children: [
          {
            name: 'Manage Charts Of Accounts',
            link: '/keuangan/manage-chart-of-account',
          },
          {
            name: 'Neraca',
            link: '/keuangan/laporan-neraca',
          },
          {
            name: 'Laba-Rugi',
            link: '/keuangan/laporan-laba-rugi',
          },
          {
            name: 'Arus Kas',
            link: '/keuangan/laporan-arus-kas',
          },
          {
            name: 'Jurnal Umum',
            link: '/keuangan/jurnal-umum',
          },
          {
            name: 'Jurnal Pembayaran AP',
            link: '/keuangan/jurnal-pembayaran-ap',
          },
          {
            name: 'Jurnal Pembelian',
            link: '/keuangan/jurnal-rn',
          },
          {
            name: 'Jurnal Retur Pembelian',
            link: '/keuangan/jurnal-retur-pembelian',
          },
          {
            name: 'Jurnal Penerimaan Kas',
            link: '/keuangan/jurnal-penerimaan-kas',
          },
          {
            name: 'Jurnal Pengeluaran Kas',
            link: '/keuangan/jurnal-pengeluaran-kas',
          },
        ],
      },
    ],
  },

  {
    name: 'Periksa - Akuntansi',
    groupChildren: [
      {
        name: 'Akuntansi',
        icon: './assets/media/svg/icons/Periksa/keuangan-icon.svg',
        link: '/akuntansi',
        children: [
          {
            name: 'Dashboard Keuangan',
            link: '/akuntansi/dashboard',
          },
          {
            name: 'Jurnal Umum',
            link: '/akuntansi/jurnal/umum',
          },
          {
            name: 'Jurnal Berulang',
            link: '/akuntansi/jurnal/berulang',
          },
          {
            name: 'Jurnal Balik',
            link: '/akuntansi/jurnal/balik',
          },
          {
            name: 'Jurnal Penyesuaian',
            link: '/akuntansi/jurnal/penyesuaian',
          },
          {
            name: 'Antrian Persetujuan',
            link: '/akuntansi/jurnal/antrian-persetujuan',
          },
          {
            name: 'Neraca Saldo',
            link: '/akuntansi/buku-besar/neraca-saldo',
          },
          {
            name: 'Mutasi per Akun',
            link: '/akuntansi/buku-besar/mutasi',
          },
          {
            name: 'Jurnal Transaksi',
            link: '/akuntansi/buku-besar/jurnal-transaksi',
          },
          {
            name: 'Penerimaan Kas & Bank',
            link: '/akuntansi/kas-bank/penerimaan',
          },
          {
            name: 'Pengeluaran Kas & Bank',
            link: '/akuntansi/kas-bank/pengeluaran',
          },
          {
            name: 'Piutang Usaha',
            link: '/akuntansi/piutang-hutang/piutang',
          },
          {
            name: 'Hutang Usaha',
            link: '/akuntansi/piutang-hutang/hutang',
          },
          {
            name: 'Jasa Tenaga Medis',
            link: '/akuntansi/piutang-hutang/fee-tenaga-medis',
          },
          {
            name: 'Hutang Lain-lain',
            link: '/akuntansi/piutang-hutang/hutang-lain',
          },
          {
            name: 'Beban Operasional',
            link: '/akuntansi/beban-anggaran/beban',
          },
          {
            name: 'Anggaran Biaya',
            link: '/akuntansi/beban-anggaran/anggaran',
          },
          {
            name: 'Kartu Aset',
            link: '/akuntansi/aset/kartu',
          },
          {
            name: 'Penyusutan Otomatis',
            link: '/akuntansi/aset/penyusutan',
          },
          {
            name: 'Pelepasan Aset',
            link: '/akuntansi/aset/disposal',
          },
          {
            name: 'Revaluasi',
            link: '/akuntansi/aset/revaluasi',
          },
          {
            name: 'Mutasi Aset',
            link: '/akuntansi/aset/mutasi',
          },
          {
            name: 'Periode Akuntansi',
            link: '/akuntansi/periode-akuntansi',
          },
        ],
      },
      {
        name: 'Laporan Keuangan',
        icon: './assets/media/svg/icons/Periksa/keuangan-icon.svg',
        link: '/akuntansi/laporan',
        children: [
          {
            name: 'Posisi Keuangan (Neraca)',
            link: '/akuntansi/laporan/neraca',
          },
          {
            name: 'Laba Rugi',
            link: '/akuntansi/laporan/laba-rugi',
          },
          {
            name: 'Arus Kas',
            link: '/akuntansi/laporan/arus-kas',
          },
          {
            name: 'Buku Besar per Akun',
            link: '/akuntansi/laporan/buku-besar',
          },
          {
            name: 'Daftar Aset',
            link: '/akuntansi/laporan/daftar-aset',
          },
          {
            name: 'Jadwal Penyusutan',
            link: '/akuntansi/laporan/jadwal-penyusutan',
          },
          {
            name: 'Beban Penyusutan',
            link: '/akuntansi/laporan/beban-penyusutan',
          },
        ],
      },
      {
        name: 'Master Akuntansi',
        icon: './assets/media/svg/icons/Periksa/keuangan-icon.svg',
        link: '/master-akuntansi',
        children: [
          {
            name: 'Bagan Akun',
            link: '/master-akuntansi/bagan-akun',
          },
          {
            name: 'Klasifikasi Akun',
            link: '/master-akuntansi/klasifikasi-akun',
          },
          {
            name: 'Pemetaan Akun Transaksi (Akuntansi)',
            link: '/master-akuntansi/pemetaan-akun',
          },
          {
            name: 'Mapping COA — Modul Operasional',
            link: '/master-keuangan/mapping-coa',
          },
          {
            name: 'Kategori Aset',
            link: '/master-akuntansi/kategori-aset',
          },
        ],
      },
    ],
  },

  {
    name: 'Periksa - Marketing',
    groupChildren: [
      {
        name: 'Marketing',
        icon: './assets/media/svg/icons/Periksa/marketing-icon.svg',
        link: '/marketing',
        children: [
          {
            name: 'Manage Kupon',
            link: '/marketing/diskon-pembayaran',
          },
        ],
      },
    ],
  },
  {
    name: 'Periksa - Logistik',
    groupChildren: [
      {
        name: 'Logistik',
        icon: './assets/media/svg/icons/Periksa/logistik-icon.svg',
        link: '/logistik',
        children: [
          {
            name: 'Manage Data Barang',
            link: '/logistik/manage-data-barang',
          },
          {
            name: 'Input Data Barang/Bahan/Alkes/Obat',
            link: '/logistik/tambah-data-barang',
          },
          {
            name: 'Manage Harga Jual Barang',
            link: '/logistik/manage-tarif-item-jual',
          },
          {
            name: 'Manage Bill Of Material',
            link: '/logistik/manage-bill-of-material',
          },
          {
            name: 'Transaksi Bill Of Material',
            link: '/logistik/transaksi-bill-of-material',
          },
          {
            name: 'Manage Goods Receiving',
            link: '/procurement/purchase-invoice',
          },
          {
            name: 'Manage Retur Pembelian',
            link: '/logistik/manage-purchase-retur',
          },
          {
            name: 'Manage Stock Opname',
            link: '/logistik/manage-stock-opname',
          },
          {
            name: 'Manage Stock Barang',
            link: '/logistik/manage-stock-barang',
          },
          {
            name: 'Manage Peminjaman Barang',
            link: '/logistik/manage-peminjaman-barang',
          },
          // {
          //   name: 'Ketersediaan Barang By Transaksi',
          //   link: '/logistik/ketersediaan-barang-by-transaksi',
          // },
          {
            name: 'Ketersediaan Barang By Stok',
            link: '/logistik/ketersediaan-barang-by-stok',
          },
          {
            name: 'Item Non Aktif',
            link: '/logistik/item-non-aktif',
          },
          {
            name: 'Manage Penyesuaian Stok Barang',
            link: '/logistik/adjustment-barang',
          },
          {
            name: 'Manage Pemakaian Barang',
            link: '/logistik/pemakaian-barang',
          },
          {
            name: 'Manage Retur Pemakaian Barang',
            link: '/logistik/retur-pemakaian-barang',
          },
          {
            name: 'Forecasting Barang',
            link: '/logistik/forecasting-barang',
          },
          {
            name: 'Forecasting Persediaan',
            link: '/logistik/forecasting-persediaan',
          },
          {
            name: 'Manage Forecasting',
            link: '/logistik/manage-forecasting',
          },
          {
            name: 'Penjualan Barang',
            link: '/logistik/manage-penjualan-barang',
          },
          {
            name: 'Retur Penjualan Barang',
            link: '/logistik/retur-penjualan-barang',
          },
        ],
      },
      {
        name: 'Distribusi Logistik',
        icon: './assets/media/svg/icons/Periksa/logistik-icon.svg',
        link: '/logistik',
        children: [
          {
            name: 'Manage Permintaan Distribusi',
            link: '/logistik/manage-permintaan-gudang',
          },
          {
            name: 'Manage Penerimaan Distribusi',
            link: '/logistik/manage-pengambilan-gudang',
          },
          {
            name: 'Permintaan Distribusi CITO',
            link: '/logistik/permintaan-gudang-cito/permintaan',
          },
          {
            name: 'Pengambilan Distribusi CITO',
            link: '/logistik/permintaan-gudang-cito/pengambilan',
          },
          {
            name: 'Retur Permintaan Gudang',
            link: '/logistik/retur-permintaan-gudang',
          },
        ],
      },
      {
        name: 'Procurement',
        icon: './assets/media/svg/icons/Periksa/logistik-icon.svg',
        link: '/procurement',
        children: [
          {
            name: 'Manage Harga Beli Barang',
            link: '/procurement/tarif-barang-beli',
          },
          {
            name: 'Manage Supplier',
            link: '/procurement/manage-supplier',
          },
          {
            name: 'Purchase Request',
            link: '/procurement/purchase-request',
          },
          {
            name: 'Purchase Order',
            link: '/procurement/purchase-order',
          },
          {
            name: 'Perencanaan Pembelian',
            link: '/logistik/manage-perencanaan-pembelian',
          },
        ],
      },
      {
        name: 'Delivery',
        icon: './assets/media/svg/icons/Periksa/delivery-icon.svg',
        single: true,
        link: '/delivery',
      },
    ],
  },
  {
    name: 'Periksa - HR',
    groupChildren: [
      {
        name: 'Pegawai',
        icon: './assets/media/svg/icons/Periksa/pegawai-icon.svg',
        link: '/pegawai',
        children: [
          {
            name: 'Data Pegawai',
            link: '/pegawai/data-pegawai',
          },
          {
            name: 'Riwayat Pelatihan Jabatan',
            link: '/pegawai/riwayat-pelatihan-jabatan',
          },
          {
            name: 'Riwayat Pelatihan Teknis',
            link: '/pegawai/riwayat-pelatihan-teknis',
          },
          {
            name: 'Riwayat Pelatihan Wajib',
            link: '/pegawai/riwayat-pelatihan-wajib',
          },
          // {
          //   name: 'Tes Tampilan Profile',
          //   link: '/pegawai/tes-tampilan-profile',
          // },
          // {
          //   name: 'Pegawai V2',
          //   link: '/pegawai/data-pegawai/componen',
          // },
          {
            name: 'Riwayat Pemeriksaan Kesehatan',
            link: '/pegawai/riwayat-pemeriksaan-kesehatan',
          },
          {
            name: 'Riwayat Pendidikan',
            link: '/pegawai/riwayat-pendidikan',
          },
          {
            name: 'Riwayat Penghargaan',
            link: '/pegawai/riwayat-penghargaan',
          },
          {
            name: 'Riwayat Jabatan',
            link: '/pegawai/riwayat-jabatan',
          },
          {
            name: 'Riwayat Keluarga',
            link: '/pegawai/riwayat-keluarga',
          },
          {
            name: 'Riwayat Evaluasi Kinerja',
            link: '/pegawai/riwayat-evaluasi-kerjaan',
          },
          {
            name: 'Riwayat Kredensial',
            link: '/pegawai/riwayat-kredensial',
          },

          {
            name: 'Riwayat Kepangkatan',
            link: '/pegawai/riwayat-kepangkatan',
          },
          {
            name: 'Riwayat Kenaikan Gaji Berkala',
            link: '/pegawai/riwayat-kgb',
          },
          {
            name: 'Riwayat Pengalaman Kerja',
            link: '/pegawai/riwayat-tempat-kerja',
          },
          {
            name: 'Riwayat Fasilitas',
            link: '/pegawai/riwayat-fasilitas',
          },
          {
            name: 'Riwayat Kepegawaian',
            link: '/pegawai/riwayat-kontrak',
          },
          {
            name: 'Riwayat Sanksi',
            link: '/pegawai/riwayat-sanksi',
          },
          {
            name: 'Riwayat Sertifikat',
            link: '/pegawai/riwayat-sertifikat',
          },
          {
            name: 'Riwayat THLS',
            link: '/pegawai/riwayat-thls',
          },
          {
            name: 'Manage Pengembangan SDM',
            link: '/pegawai/manage-pengembangan-sdm/pengembangan-sdm',
          },
          {
            name: 'Manage Pengadministrasian Data Pegawai',
            link: '/pegawai/manage-pengadministrasian-data-pegawai',
          },
          {
            name: 'Manage Retensi Staff',
            link: '/pegawai/manage-pengembangan-sdm/retensi-staff',
          },
          {
            name: 'Manage Kompensasi Staff',
            link: '/pegawai/manage-pengembangan-sdm/kompensasi-staff',
          },
          {
            name: 'Manage Penilaian Kinerja Pegawai',
            link: '/pegawai/manage-pengembangan-sdm/penilaian-kinerja-pegawai',
          },
          {
            name: 'Manage Proses Rekrutmen & Seleksi Staf Klinis & Non Klinis',
            link: '/pegawai/manage-proses-rekrutmen-seleksi',
          },
          {
            name: 'Setting Penanggung Jawab',
            link: '/pegawai/setting-penanggung-jawab',
          },
          {
            name: 'Laporan Kinerja Harian',
            link: '/pegawai/laporan-kinerja-harian',
          },
          {
            name: 'Manage Pernyataan Kewaspadaan Terhadap Covid 19',
            link: '/pegawai/manage-pernyataan-kewaspadaan-terhadap-covid19',
          },
          {
            name: 'Bukti Orientasi',
            link: '/pegawai/bukti-orientasi',
          },
          {
            name: 'Uraian Tugas',
            link: '/pegawai/uraian-tugas',
          },
          {
            name: 'Dokumen Persyaratan Kenaikan Pangkat',
            link: '/pegawai/dokumen-persyaratan-kenaikan-pangkat',
          },
          {
            name: 'Penilaian Kinerja Pegawai Dinas Kesehatan Angkatan Laut',
            link: '/pegawai/penilaian-kinerja-dinkes',
            clinicIds: [31],
          },
        ],
      },
      {
        name: 'Absensi',
        icon: './assets/media/svg/icons/Periksa/absensi-icon.svg',
        link: '/e-office',
        children: [
          {
            name: 'Absensi',
            link: '/sarana-prasarana/absensi',
          },
          {
            name: 'Manage Jam Kerja',
            link: '/pegawai/jam-kerja',
          },
        ],
      },
    ],
  },
  {
    name: 'Periksa - Administrasi',
    groupChildren: [
      {
        name: 'Cuti',
        icon: './assets/media/svg/icons/Periksa/cuti-icon.svg',
        link: '/e-office',
        children: [
          {
            name: 'Manage Approval Cuti',
            link: '/pegawai/approval-surat-cuti',
          },
          {
            name: 'Manage Permohonan Cuti',
            link: '/pegawai/manage-permohonan-cuti',
          },
          {
            name: 'Manage Approval Unit Kerja',
            link: '/pegawai/approval-unit-kerja',
          },
        ],
      },
      {
        name: 'E-Office',
        icon: './assets/media/svg/icons/Periksa/e-office-icon.svg',
        link: '/e-office',
        children: [
          {
            name: 'Surat Keluar',
            link: '/e-office/manage-surat-keluar',
          },
          {
            name: 'Manage File',
            link: '/e-office/manage-file-2',
          },
          {
            name: 'Surat Masuk',
            link: '/e-office/manage-surat-masuk',
          },
          {
            name: 'Master E-Office',
            link: '/e-office/master-to-inbox',
          },
        ],
      },
      {
        name: 'Sarana dan Prasarana',
        icon: './assets/media/svg/icons/Periksa/sarana-prasarana-icon.svg',
        link: '/sarana-prasarana',
        children: [
          {
            name: 'Help Desk',
            link: '/sarana-prasarana/help-desk',
          },
          {
            name: 'Tindak Lanjut Help Desk Maintenance',
            link: '/sarana-prasarana/tindak-lanjut-helpdesk',
          },
          {
            name: 'Manage Perizinan',
            link: '/sarana-prasarana/perizinan',
          },
          {
            name: 'Manage Kategori Maintenance',
            link: '/sarana-prasarana/kategori-maintenance',
          },
        ],
      },
      {
        name: 'Izin Pegawai',
        icon: './assets/media/svg/icons/Periksa/cuti-icon.svg',
        link: '/e-office',
        children: [
          {
            name: 'Permohonan Izin',
            link: '/pegawai/manage-permohonan',
          },
          {
            name: 'Approval Izin',
            link: '/pegawai/manage-permohonan-approval',
          },
        ],
      },
    ],
  },
  {
    name: 'Periksa - CMS',
    groupChildren: [
      {
        name: 'Customer Service',
        icon: './assets/media/svg/icons/Periksa/pusat-informasi-icon.svg',
        single: true,
        link: '/customer-service',
      },
      {
        name: 'Pusat Informasi',
        icon: './assets/media/svg/icons/Periksa/medical-record-icon.svg',
        link: '/pusat-informasi',
        children: [
          {
            name: 'Manage Artikel',
            link: '/pusat-informasi/artikel',
          },
          {
            name: 'Manage Informasi',
            link: '/pusat-informasi/manage-informasi-umum',
          },
          {
            name: 'Manage Informasi Pasien',
            link: '/pusat-informasi/manage-informasi-pasien',
          },
        ],
      },
      {
        name: 'Kotak Pesan',
        icon: './assets/media/svg/icons/Periksa/medical-record-icon.svg',
        single: true,
        link: '/upload-laporan/kotak-masuk',
      },
      {
        name: 'Dashboard WhatsApp',
        icon: './assets/media/svg/icons/Periksa/whatsapp-icon.svg',
        link: '/cms/dashboard-whatsapp',
        single: true,
      },
      {
        name: 'Broadcast WhatsApp',
        icon: './assets/media/svg/icons/Periksa/whatsapp-icon.svg',
        link: '/cms/broadcast-whatsapp',
        single: true,
      },
      {
        name: 'Master Kontak',
        icon: './assets/media/svg/icons/Periksa/whatsapp-icon.svg',
        link: '/cms/master-kontak',
      },
      {
        name: 'Manage Tag ',
        icon: './assets/media/svg/icons/Periksa/medical-record-icon.svg',
        link: '/cms/manage-tag',
        single: true,
      },
    ],
  },
  {
    name: 'Periksa - TV Media',
    groupChildren: [
      {
        name: 'TV Informasi Media',
        icon: './assets/media/svg/icons/Periksa/tv-informasi-icon.svg',
        link: '/tv-media',
        children: [
          {
            name: 'Loket',
            link: '/loket/all',
          },
          {
            name: 'Loket (Farmasi)',
            link: '/loket/farmasi',
          },
          {
            name: 'Manage Media Informasi',
            link: '/e-office/running-text',
          },
          {
            name: 'Video Panduan Pengguna',
            link: '/e-office/video-panduan-pengguna',
          },
          {
            name: 'TV Display Loket',
            newTab: true,
            link: '/tv-media/monitor',
          },
          {
            name: 'TV Display Loket (Farmasi)',
            newTab: true,
            link: '/tv-media/monitor?q=farmasi',
          },
          {
            name: 'TV Display Loket Farmasi',
            newTab: true,
            link: '/tv-media/monitor-farmasi',
          },
          {
            name: 'TV Display Loket Farmasi V2',
            newTab: true,
            link: '/tv-media/monitor-farmasi-v2',
          },
          {
            name: 'Dashboard Monitoring Antrian Resep',
            newTab: true,
            link: '/tv-media/dashboard-monitoring-proses-resep',
            clinicIds: [1, 641],
          },
          {
            name: 'TV Display Penunjang',
            newTab: true,
            link: '/tv-media/monitor-penunjang-select',
          },
          {
            name: 'TV Display Jadwal Dokter',
            newTab: true,
            link: '/tv-media/monitor-jadwal-dokter',
          },
          {
            name: 'TV Display Jadwal Operasi',
            newTab: true,
            link: '/tv-media/monitor-jadwal-operasi',
          },
          {
            name: 'TV Display Tracer Pasien',
            newTab: true,
            link: '/tv-media/monitor-tracer-pasien',
          },
          {
            name: 'TV Display Antrian Poli',
            newTab: true,
            link: '/tv-media/outpatient-queue',
          },
          {
            name: 'Display Anjungan Mandiri',
            newTab: true,
            link: '/tv-media/anjungan-mandiri',
          },
          {
            name: 'Display Anjungan Farmasi',
            newTab: true,
            link: '/tv-media/anjungan-mandiri?type=farmasi',
          },
          // {
          //   name: 'Display Anjungan Antrian BPJS',
          //   newTab: true,
          //   link: '/tv-media/anjungan-bpjs',
          // },
          {
            name: 'Display Pendaftaran Mandiri',
            newTab: true,
            link: '/tv-media/pendaftaran-mandiri',
          },
          {
            name: 'Display Pendaftaran Mandiri BPJS',
            newTab: true,
            link: '/tv-media/pendaftaran-mandiri-bpjs',
          },
          {
            name: 'TV Display IGD',
            newTab: true,
            link: '/tv-media/monitor-display-igd',
          },
          {
            name: 'TV Display EWS',
            newTab: true,
            link: '/tv-media/monitor-display-ews',
          },
          {
            name: 'TV Display Antrian Kasir',
            newTab: true,
            link: '/tv-media/monitor-antrian-kasir',
          },
        ],
      },
    ],
  },
  {
    name: 'Periksa - Laporan',
    groupChildren: [
      {
        name: 'Laporan',
        icon: './assets/media/svg/icons/Periksa/laporan-medis-icon.svg',
        link: '/laporan',
        children: [],
      },
      {
        name: 'Laporan Farmasi',
        icon: './assets/media/svg/icons/Periksa/laporan-farmasi-icon.svg',
        link: '/laporan',
        children: [
          {
            name: 'Laporan Detail Psikotropika dan Narkotika',
            link: '/laporan/laporan-detail-psiko-narko',
          },
          {
            name: 'Laporan Telaah Resep',
            link: '/laporan/laporan-telaah-obat',
          },
          {
            name: 'Laporan Verifikasi Resep',
            link: '/laporan/laporan-verifikasi',
          },
          {
            name: 'Laporan Resep Generik',
            link: '/laporan/laporan-resep-generik',
          },
          {
            name: 'Laporan Waktu Respon Resep',
            link: '/laporan/laporan-waktu-respon-resep',
          },
          {
            name: 'Laporan Resep Digital',
            link: '/laporan/laporan-resep-digital',
          },
          {
            name: 'Laporan Narkotika',
            link: '/laporan/laporan-narkotika',
          },
          {
            name: 'Laporan Antibiotika',
            link: '/laporan/laporan-antibiotika',
          },
          {
            name: 'Laporan Psikotropika',
            link: '/laporan/laporan-psikotropika',
          },
          {
            name: 'Laporan Pemakaian dan Penerimaan Obat dan Alkes',
            link: '/laporan/laporan-pemakaian-penerimaan-obat-alkes',
          },
          // {
          //   name: 'Laporan Pengobatan Pasien',
          //   link: '/laporan/laporan-pengobatan-pasien',
          // },
          {
            name: 'Laporan Pendapatan Farmasi',
            link: '/laporan/laporan-pendapatan-farmasi',
          },
          {
            name: 'Laporan Resep dan BHP',
            link: '/laporan/laporan-resep-dan-bhp',
          },
          {
            name: 'Laporan Rata - Rata Penjualan Obat',
            link: '/laporan/laporan-mean-penjualan-obat',
          },
          {
            name: 'Laporan Fornas Obat',
            link: '/laporan/laporan-fornas-obat',
          },
          {
            name: 'Laporan Waktu Respon Antrian Farmasi',
            link: '/laporan/laporan-respon-time-antrian-farmasi',
          },
          {
            name: 'Laporan Tuslah',
            link: '/laporan/laporan-tuslah',
          },
          {
            name: 'Laporan Retriksi Obat',
            link: '/laporan/laporan-retriksi-obat',
          },
          {
            name: 'Laporan Rekapan Penjualan Obat Pasien',
            link: '/laporan/laporan-rekap-penjualan-obat-pasien-rajal',
            clinicIds: [60, 1],
          },
          {
            name: 'Laporan Obat Antibiotik',
            link: '/laporan/laporan-obat-antibiotik',
          },
        ],
      },
      {
        name: 'Laporan Kasir',
        icon: './assets/media/svg/icons/Periksa/laporan-kasir-icon.svg',
        link: '/laporan',
        children: [
          {
            name: 'Laporan Kasir Pasien',
            link: '/laporan/laporan-kasir-pasien',
          },
          {
            name: 'Detail Laporan Kasir Per Mahasiswa',
            link: '/laporan/detail-laporan-kasir-per-mahasiswa',
          },
          {
            name: 'Laporan Pembayaran Piutang',
            link: '/laporan/laporan-pembayaran-piutang',
          },
          {
            name: 'Detail Laporan Kasir',
            link: '/laporan/detail-laporan-kasir',
          },
          {
            name: 'Laporan Rekap Kasir',
            link: '/laporan/detail-laporan-rekap-kasir',
          },
          {
            name: 'Detail Laporan Kasir Mobile',
            link: '/laporan/detail-laporan-kasir-mobile',
          },
          // {
          //   name: 'Detail Laporan History Kasir',
          //   link: '/laporan/detail-laporan-history-kasir',
          // },
          {
            name: 'Laporan History Kasir',
            link: '/laporan/riwayat-laporan-kasir',
          },
          {
            name: 'Ringkasan Laporan Kasir/POS',
            link: '/laporan/ringkasan-laporan-kasir',
          },
          {
            name: 'Detail Laporan Kasir By Dokter',
            link: '/laporan/detail-laporan-kasir-pos-by-dokter',
          },
          {
            name: 'Laporan Diskon',
            link: '/laporan/laporan-diskon',
          },
          // {
          //   name: 'Laporan History Kasir By Dokter',
          //   link: '/laporan/laporan-history-kasir-by-dokter',
          // },
          {
            name: 'Laporan Rekap Kasir By Poli',
            link: '/laporan/laporan-rekap-kasir-by-poli',
          },
          {
            name: 'Laporan Rekap Setoran Kasir Rawat Jalan',
            link: '/laporan/laporan-rekap-setoran-kasir-rawat-jalan',
            clinicIds: [1, 173],
          },
          {
            name: 'Laporan Kasir Pasien Bedah OK Major',
            link: '/laporan/laporan-kasir-pasien-bedah-ok-major',
            clinicIds: [7, 1],
          },
        ],
      },
      {
        name: 'Laporan Keuangan',
        icon: './assets/media/svg/icons/Periksa/laporan-kasir-icon.svg',
        link: '/laporan',
        children: [
          {
            name: 'Laporan Rekapitulasi Penjualan',
            link: '/laporan/laporan-rekapitulasi-penjualan',
          },
          {
            name: 'Laporan Utang Supplier',
            link: '/laporan/laporan-hutang',
          },
          {
            name: 'Laporan Retur Pembelian',
            link: '/laporan/laporan-retur-pembelian',
          },
          {
            name: 'Laporan Transaksi Tindakan',
            link: '/laporan/laporan-transaksi-tindakan-bulanan',
          },
          {
            name: 'Laporan Transaksi Obat',
            link: '/laporan/laporan-transaksi-obat-bulanan',
          },
          {
            name: 'Laporan Analisa Penjualan',
            link: '/laporan/laporan-analisa-penjualan',
          },
          {
            name: 'Laporan Pembayaran Hutang',
            link: '/laporan/laporan-pembayaran-hutang',
          },
          {
            name: 'Laporan Tukar Faktur',
            link: '/laporan/laporan-tukar-faktur',
          },
          {
            name: 'Laporan Pemasukan',
            link: '/laporan/laporan-pemasukan',
          },
          {
            name: 'Laporan Jasa Tenaga Medis',
            link: '/laporan/laporan-jasa-tenaga-medis',
          },
          {
            name: 'Laporan Pasien Belum Melakukan Pembayaran',
            link: '/laporan/laporan-pasien-belum-melakukan-pembayaran',
          },

          {
            name: 'Laporan Pendapatan Harian Kasir',
            link: '/laporan/laporan-pendapatan-harian-kasir',
          },
          {
            name: 'Laporan Profit Barang',
            link: '/laporan/laporan-profit-barang',
          },
          {
            name: 'Laporan Penjualan HPP',
            link: '/laporan/laporan-penjualan-hpp',
          },
          {
            name: 'Laporan Jasa Operasi',
            link: '/laporan/laporan-jasa-operasi',
          },

          {
            name: 'Laporan Penerimaan Barang',
            link: '/laporan/laporan-keuangan-penerimaan-barang',
          },
          {
            name: 'Laporan Pendapatan',
            link: '/laporan/laporan-pendapatan-tahunan',
          },

          {
            name: 'Laporan Pembayaran EDC',
            link: '/laporan/laporan-pembayaran-edc',
          },
          {
            name: 'Laporan Pendapatan Instalasi',
            link: '/laporan/laporan-pendapatan-instalasi-perbulan',
          },
          {
            name: 'Laporan Pendapatan Mobile Payment',
            link: '/laporan/laporan-pendapatan-mobile-payment-tahunan',
          },
          {
            name: 'Laporan Penjualan Margin',
            link: '/laporan/laporan-penjualan-margin',
          },
          {
            name: 'Laporan Pendapatan Dengan MDR',
            link: '/laporan/laporan-pendapatan-dengan-mdr',
          },
          {
            name: 'Laporan Jasa Medis BPJS Non IGD',
            link: '/laporan/laporan-jasa-medis-bpjs-non-igd',
          },
          {
            name: 'Laporan Jasa Medis BPJS IGD',
            link: '/laporan/laporan-jasa-medis-bpjs-igd',
          },
          {
            name: 'Laporan Jasa Medis Umum Non IGD',
            link: '/laporan/laporan-jasa-medis-umum-non-igd',
          },
          {
            name: 'Laporan Jasa Medis Umum IGD',
            link: '/laporan/laporan-jasa-medis-umum-igd',
          },
          {
            name: 'Laporan Pembayaran Asuransi',
            link: '/laporan/laporan-pembayaran-asuransi',
          },
          {
            name: 'Laporan QRIS',
            link: '/laporan/laporan-qris',
          },
          {
            name: 'Laporan Pembayaran O/P Jasa Tenaga Medis',
            link: '/laporan/laporan-pembayaran-op-jasa-tenaga-medis',
          },
        ],
      },
      {
        name: 'Laporan Logistik',
        icon: './assets/media/svg/icons/Periksa/laporan-logistik-icon.svg',
        link: '/laporan',
        children: [
          {
            name: 'Laporan Ketersediaan Barang Dengan Nominal',
            link: '/laporan/laporan-ketersediaan-barang-dengan-nominal',
          },
          {
            name: 'Laporan Goods Receiving',
            link: '/laporan/laporan-goods-receiving',
          },
          {
            name: 'Laporan Distribusi',
            link: '/laporan/laporan-distribusi',
          },
          {
            name: 'Laporan Purchase Order',
            link: '/laporan/laporan-purchase-order',
          },
          {
            name: 'Laporan Barang Keluar',
            link: '/laporan/laporan-barang-keluar',
          },
          {
            name: 'Laporan Mutasi Stok',
            link: '/laporan/laporan-mutasi-stok',
          },
          {
            name: 'Laporan History Stock',
            link: '/laporan/laporan-rekapitulasi-barang',
          },
          {
            name: 'Laporan Mutasi Stok Gudang',
            link: '/laporan/laporan-mutasi-stok-gudang',
          },
          {
            name: 'Laporan Penyesuaian Stok Barang',
            link: '/laporan/laporan-adjustment-stock',
          },
          {
            name: 'Laporan Jenis Pemakaian Barang',
            link: '/laporan/laporan-jenis-pemakaian-barang',
          },
          {
            name: 'Laporan Produksi',
            link: '/laporan/laporan-produksi',
          },
          {
            name: 'Laporan Stock Opname',
            link: '/laporan/laporan-stock-opname',
          },
          {
            name: 'Laporan Rincian Barang Persediaan',
            link: '/laporan/laporan-rincian-barang-persediaan-fifo',
          },
          {
            name: 'Laporan Pemakaian Stock Barang Metode FIFO',
            link: '/laporan/laporan-pemakaian-stock-barang',
          },
          {
            name: 'Rekapan Pemakaian Barang FIFO',
            link: '/laporan/rekapan-pemakaian-barang',
          },
          {
            name: 'Laporan Rekapan Rincian Buku Persediaan',
            link: '/laporan/laporan-rekapan-rincian-buku-persediaan',
          },
          {
            name: 'Rincian PJK Sakti',
            link: '/laporan/rincian-pjk-sakti',
            clinicIds: [173, 1],
          },
        ],
      },
      {
        name: 'Laporan Logistik Farmasi',
        icon: './assets/media/svg/icons/Periksa/laporan-farmasi-icon.svg',
        link: '/laporan',
        children: [
          {
            name: 'Laporan Obat Kadaluwarsa',
            link: '/laporan/laporan-obat-kadaluwarsa',
          },
          {
            name: 'Laporan Obat Akan Kadaluwarsa',
            link: '/laporan/laporan-obat-akan-kadaluwarsa',
          },
        ],
      },
      {
        name: 'Laporan Medis',
        icon: './assets/media/svg/icons/Periksa/laporan-medis-icon.svg',
        link: '/laporan',
        children: [
          {
            name: 'Laporan Imunisasi',
            link: '/laporan/laporan-imunisasi',
          },
          {
            name: 'Laporan Analisis',
            link: '/laporan/laporan-analisis',
          },
          {
            name: 'Laporan Asesmen Pasien',
            link: '/laporan/laporan-asesmen-pasien',
          },
          {
            name: 'Laporan Laboratorium',
            link: '/laporan/laporan-laboratorium',
          },
          {
            name: 'Laporan Radiologi',
            link: '/laporan/laporan-radiologi',
          },
          {
            name: 'Laporan Radiologi Kunjungan',
            link: '/laporan/laporan-radiologi-kunjungan',
          },
          {
            name: 'Laporan Status Pasien Covid',
            link: '/laporan/laporan-status-pasien-covid',
          },
          {
            name: 'Laporan Keperawatan',
            link: '/laporan/laporan-keperawatan',
          },
          {
            name: 'Laporan Patologi Anatomi',
            link: '/laporan/laporan-patologi-anatomi',
          },
          {
            name: 'Laporan Permintaan Bahan',
            link: '/laporan/laporan-permintaan-bahan',
          },
          {
            name: 'Laporan Pelayanan UGD',
            link: '/laporan/laporan-pelayanan-ugd',
          },
          {
            name: 'Laporan Mikrobiologi',
            link: '/laporan/laporan-mikrobiologi',
          },
          {
            name: 'Laporan Bahan Alat Medis',
            link: '/laporan/laporan-bahan-alat-medis',
          },
          {
            name: 'Laporan Rujukan Pasien Internal dan Eksternal',
            link: '/laporan/laporan-pasien-internal-eksternal',
          },
          {
            name: 'Laporan CPPT',
            link: '/laporan/laporan-cppt',
          },
          {
            name: 'Laporan Monitoring Pasien',
            link: '/laporan/laporan-monitoring-pasien',
          },
          {
            name: 'Laporan Hipertensi',
            link: '/laporan/laporan-hipertensi',
          },
          {
            name: 'Laporan Adime Gizi',
            link: '/laporan/laporan-adime-gizi',
          },
          {
            name: 'Laporan TBC',
            link: '/laporan/laporan-tbc',
          },
          {
            name: 'Laporan Tindakan By Dokter',
            link: '/laporan/laporan-tindakan-by-dokter',
          },
          {
            name: 'Laporan Tindakan Rawat Inap By Dokter',
            link: '/laporan/laporan-tindakan-rawat-inap-by-dokter',
          },
          {
            name: 'Laporan Tindakan By Perawat',
            link: '/laporan/laporan-tindakan-by-perawat',
          },
          {
            name: 'Laporan Tindakan Pasien',
            link: '/laporan/laporan-tindakan-pasien',
          },
          {
            name: 'Laporan Tindakan By Mahasiswa',
            link: '/laporan/laporan-tindakan-by-mahasiswa',
          },
          {
            name: 'Laporan Partograf',
            link: '/laporan/laporan-partograf',
          },
          {
            name: 'Laporan Formulir Medis',
            link: '/laporan/laporan-formulir-medis',
          },
          {
            name: 'Laporan Surat Keterangan',
            link: '/laporan/laporan-surat-keterangan',
          },
          {
            name: 'Laporan OHIS',
            link: '/laporan/laporan-ohis',
          },
          {
            name: 'Laporan Bedah Anestesi',
            link: '/laporan/laporan-bedah-anastesi',
          },
          {
            name: 'Laporan Penilaian Mahasiswa',
            link: '/laporan/laporan-penilaian-mahasiswa',
          },
          {
            name: 'Laporan Edukasi Integrasi',
            link: '/laporan/laporan-edukasi-integrasi-dokter',
          },
          {
            name: 'Laporan Kegiatan Pelayanan Rawat Darurat',
            link: '/laporan/laporan-kegiatan-pelayanan-rawat-darurat',
            clinicIds: [173, 1],
          },
          {
            name: 'Laporan Rekapitulasi Kegiatan Pelayanan Rawat Darurat',
            link: '/laporan/laporan-rekapitulasi-kegiatan-pelayanan-rawat-darurat',
            clinicIds: [1, 173],
          },
          {
            name: 'Laporan 3.C.1 Rekapitulasi Kegiatan Pelayanan Rawat Darurat',
            link: '/laporan/laporan-3c1-rekapitulasi-kegiatan-pelayanan-rawat-darurat',
            clinicIds: [1, 20],
          },
          {
            name: 'Laporan CSSD',
            link: '/laporan/laporan-cssd-semua',
          },
        ],
      },
      {
        name: 'Laporan Medical Record',
        icon: './assets/media/svg/icons/Periksa/laporan-medrec-icon.svg',
        link: '/laporan',
        children: [
          {
            name: 'Laporan Telemedika',
            link: '/laporan/laporan-telemedicine',
          },
          {
            name: 'Laporan Alos',
            link: '/laporan/laporan-alos',
          },
          {
            name: 'Laporan BOR',
            link: '/laporan/laporan-bor',
          },
          {
            name: 'Rekapitulasi Pasien Baru',
            link: '/laporan/laporan-rekapitulasi-pasien-baru',
          },
          {
            name: 'Laporan Kunjungan Pasien',
            link: '/laporan/laporan-kunjungan-pasien',
          },
          {
            name: 'Laporan Registrasi Pengunjung Poli Pasien Pulang Rawat Jalan dan Rawat Inap By Penjamin',
            link: '/laporan/laporan-kunjungan-poli-pasien-pulang-rawat-jalan-by-penjamin',
          },
          {
            name: 'Laporan Pelayanan Kesehatan',
            link: '/laporan/laporan-pelayanan-kesehatan',
          },
          {
            name: 'Laporan Kunjungan Berikutnya',
            link: '/laporan/laporan-kunjungan-berikutnya',
          },
          {
            name: 'Laporan Pengunjung',
            link: '/laporan/laporan-pengunjung',
          },
          {
            name: 'Laporan Diagnosa',
            link: '/laporan/laporan-diagnosa',
          },
          {
            name: 'Cek Laporan Kunjungan Pasien',
            link: '/laporan/cek-laporan-kunjungan-pasien',
          },
          {
            name: 'Laporan Kematian',
            link: '/laporan/laporan-kematian',
          },
          {
            name: 'Laporan Resume Medis',
            link: '/laporan/laporan-resume-medis',
          },
          {
            name: 'Perincian Pasien Masuk/Keluar Rawat Inap',
            link: '/laporan/perincian-pasien-masuk-keluar-rawat-inap',
          },
          {
            name: 'Laporan Cara Pulang',
            link: '/laporan/laporan-cara-pulang',
          },
          {
            name: 'Laporan Poli Berdasarkan Penjamin',
            link: '/laporan/laporan-poli-berdasarkan-nasabah',
          },
          {
            name: 'Laporan Pasien Pulang Rawat Inap',
            link: '/laporan/laporan-pasien-pulang-ranap',
          },
          {
            name: 'Laporan Sensus Harian Rawat Inap',
            link: '/laporan/laporan-sensus-harian-ranap',
          },
          {
            name: 'Laporan TOI',
            link: '/laporan/laporan-toi',
          },
          {
            name: 'Laporan BTO',
            link: '/laporan/laporan-bto',
          },
          {
            name: 'Laporan GDR',
            link: '/laporan/laporan-gdr',
          },
          {
            name: 'Laporan NDR',
            link: '/laporan/laporan-ndr',
          },
          {
            name: 'Laporan Rekap Dokter',
            link: '/laporan/laporan-rekap-dokter',
          },
          {
            name: 'Laporan Pemakaian Tempat Tidur',
            link: '/laporan/laporan-pemakaian-tempat-tidur',
          },
          {
            name: 'Laporan Kunjungan Dokter Rekap',
            link: '/laporan/laporan-kunjungan-dokter-rekap',
          },
          {
            name: 'Laporan Kunjungan Tiga Besar Diagnosa ICD 10',
            link: '/laporan/laporan-kunjungan-tiga-besar-diagnosa-icd',
          },
          {
            name: 'Rekap Kunjungan Penunjang By Ruang Rujukan',
            link: '/laporan/rekap-kunjungan-penunjang-by-ruang-rujukan',
          },
          {
            name: 'Laporan Rekap Kunjungan Harian Penunjang',
            link: '/laporan/laporan-rekap-kunjungan-harian-penunjang',
          },
          {
            name: 'Laporan Analisis Alur dan Mutasi Pasien ',
            link: '/laporan/laporan-analisis-alur-dan-mutasi-pasien',
          },
        ],
      },
      {
        name: 'Laporan Pegawai',
        icon: './assets/media/svg/icons/Periksa/pegawai-icon.svg',
        link: '/laporan',
        children: [
          {
            name: 'Laporan Bon Pegawai',
            link: '/laporan/laporan-bon-pegawai',
          },
          {
            name: 'Laporan Rekapitulasi Absensi',
            link: '/laporan/laporan-rekapitulasi-absensi',
          },
          {
            name: 'Laporan Absensi',
            link: '/laporan/laporan-absensi',
          },
          {
            name: 'Laporan Informasi Cuti Pegawai',
            link: '/laporan/laporan-informasi-cuti-pegawai',
          },
          {
            name: 'Laporan Help Desk',
            link: '/laporan/laporan-helpdesk',
          },
          {
            name: 'Laporan Izin Pegawai',
            link: '/laporan/laporan-izin-pegawai',
          },
        ],
      },
      {
        name: 'Laporan Logbook',
        icon: './assets/media/svg/icons/Periksa/laporan-medrec-icon.svg',
        link: '/laporan',
        children: [
          {
            name: 'Laporan Logbook Radiologi',
            link: '/laporan/laporan-logbook-radiologi',
          },
        ],
      },
      {
        name: 'Manage Laporan',
        icon: './assets/media/svg/icons/Periksa/laporan-medrec-icon.svg',
        link: '/laporan',
        children: [
          {
            name: 'Laporan Rawat Jalan',
            link: '/laporan/laporan-rawat-jalan',
            clinicIds: [1, 152],
          },
          {
            name: 'Laporan Distribusi Pelayanan Per DPJP & Poliklinik',
            link: '/laporan/laporan-distribusi-pelayanan-per-dpjp-poliklinik',
            clinicIds: [1, 152],
          },
          {
            name: 'Laporan Kegiatan Radiologi Per Hari',
            link: '/laporan/laporan-kegiatan-radiologi-per-hari',
            excludeClinicIds: [20],
          },
          {
            name: 'Laporan Kegiatan Radiologi Per Bulan',
            link: '/laporan/laporan-kegiatan-radiologi-per-bulan',
            excludeClinicIds: [20],
          },
          {
            name: 'Laporan Kegiatan Dokter Atau DPJP Per Hari',
            link: '/laporan/laporan-kegiatan-dokter-dpjp-per-hari',
            excludeClinicIds: [20],
          },
          {
            name: 'Laporan Kegiatan Dokter Atau DPJP Per Bulan',
            link: '/laporan/laporan-kegiatan-dokter-dpjp-per-bulan',
            excludeClinicIds: [20],
          },
          {
            name: 'RL 5.1 KOMPILASI MORBIDITAS PASIEN RAWAT JALAN',
            link: '/laporan/kompilasi-morbiditas-pasien-rawat-jalan',
          },
          {
            name: 'RL 4.1 KOMPILASI MORBIDITAS PASIEN RAWAT INAP',
            link: '/laporan/kompilasi-morbiditas-pasien-rawat-inap',
            excludeClinicIds: [20],
          },
          {
            name: 'RL 4.2 10 BESAR PENYAKIT RAWAT INAP',
            link: '/laporan/laporan-rl4210-besar-penyakit-ranap',
            excludeClinicIds: [20],
          },
          {
            name: 'RL 4.3 10 BESAR KEMATIAN PENYAKIT RAWAT INAP',
            link: '/laporan/rl4310-besar-kematian-penyakit-rawat-inap',
            excludeClinicIds: [20],
          },
          {
            name: 'LAPORAN BALITA',
            link: '/laporan/laporan-balita',
            excludeClinicIds: [20],
          },
          {
            name: 'Laporan Kegiatan Instalasi Per Hari',
            link: '/laporan/laporan-kegiatan-instalasi-per-hari',
            excludeClinicIds: [20],
          },
          {
            name: 'Laporan Kegiatan Instalasi Per Bulan',
            link: '/laporan/laporan-kegiatan-instalasi-per-bulan',
            excludeClinicIds: [20],
          },
          {
            name: 'Laporan Waktu Tunggu Rawat Jalan',
            link: '/laporan/laporan-waktu-tunggu-rawat-jalan',
          },
          {
            name: 'Laporan Pelayanan Instalasi Gawat Darurat (IGD)',
            link: '/laporan/laporan-pelayanan-igd',
            excludeClinicIds: [20],
          },
          {
            name: 'RL 3.4 Rekapitulasi Pengunjung',
            link: '/laporan/laporan-rl34-rekap-pengunjung',
          },
          {
            name: 'RL 3.2 REKAPITULASI KEGIATAN PELAYANAN RAWAT INAP',
            link: '/laporan/rl32-rekap-kegiatan-pelayanan-ranap',
          },
          {
            name: 'Laporan Waktu Tunggu Pasien Rawat Jalan',
            link: '/laporan/laporan-waktu-tunggu-pasien-rawat-jalan',
            clinicIds: [641, 1],
          },
          {
            name: 'Laporan Pelayanan Laboratorium',
            link: '/laporan/laporan-pelayanan-laboratorium',
          },
          {
            name: 'Laporan 3.a Data Pengunjung',
            link: '/laporan/laporan3a-data-pengunjung',
            clinicIds: [20, 1],
          },
          {
            name: 'Laporan 3.b Kunjungan Rawat Jalan',
            link: '/laporan/laporan3b-kunjungan-rawat-jalan',
            clinicIds: [20, 1],
          },
          {
            name: 'Laporan 3.e Kegiatan Kesehatan Gigi dan Mulut',
            link: '/laporan/oral-health-report',
            clinicIds: [20, 1],
          },
          {
            name: 'Laporan 3.j Pemeriksaan Laboratorium dan Kegiatan',
            link: 'laporan/laboratory-examinations-report',
            clinicIds: [20, 1],
          },
          {
            name: 'Laporan 3.h Kegiatan Pembedahan',
            link: 'laporan/laporan3h-kegiatan-pembedahan',
            clinicIds: [20, 1],
          },
          {
            name: 'Laporan 3.i Kegiatan Radiologi',
            link: 'laporan/laporan3i-kegiatan-radiologi',
            clinicIds: [20, 1],
          },
          {
            name: 'Laporan 3.c.2 Kegiatan Pelayanan Rawat Darurat',
            link: 'laporan/laporan3c2-kegiatan-pelayanan-rawat-darurat',
            clinicIds: [20, 1],
          },
          {
            name: 'Laporan 3.d.1 Rekapitulasi Kegiatan Pelayanan Rawat Inap',
            link: 'laporan/laporan3d1-rekapitulasi-kegiatan-pelayanan-rawat-inap',
            clinicIds: [20, 1],
          },
          {
            name: 'Laporan 3.d.2 Laporan Kegiatan Pelayanan Rawat Inap',
            link: 'laporan/laporan-kegiatan-pelayanan-ranap',
            clinicIds: [20, 1],
          },
          {
            name: 'Laporan Monitoring Formulir Medis Pasien',
            link: 'laporan/laporan-monitoring-formulir-medis-pasien',
          },
          {
            name: '7.A Daftar 10 Besar Penyakit Rawat Inap',
            link: '/laporan/laporan-daftar-sepuluh-besar-penyakit-ranap',
            clinicIds: [31],
          },
          {
            name: '7.B Daftar 10 Besar Penyakit Rawat Jalan',
            link: '/laporan/laporan-daftar-sepuluh-besar-penyakit-rajal',
            clinicIds: [31],
          },
          {
            name: 'Laporan IGD dan Ponek',
            link: '/laporan/laporan-igd-dan-ponek',
            clinicIds: [1, 152],
          },
        ],
      },
    ],
  },
  {
    name: 'Periksa - Bridging',
    groupChildren: [
      {
        name: 'Applicares',
        icon: './assets/media/svg/icons/Periksa/integrasi-icon.svg',
        link: '/applicares',
        children: [
          {
            name: 'Ketersediaan Kamar',
            link: '/applicares/ketersediaan-kamar',
          },
        ],
      },
      {
        name: 'Apotek',
        icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
        link: '/apotek-bpjs',
        children: [
          {
            name: 'Referensi',
            link: '/apotek-bpjs/referensi',
          },
          {
            name: 'Pelayanan Obat',
            link: '/apotek-bpjs/pelayanan-obat',
          },
          {
            name: 'Daftar Resep',
            link: '/apotek-bpjs/daftar-resep',
          },
          {
            name: 'SEP',
            link: '/apotek-bpjs/sep',
          },
          {
            name: 'Monitoring',
            link: '/apotek-bpjs/monitoring',
          },
          {
            name: 'Rekap Peserta PRB',
            link: '/apotek-bpjs/rekap-peserta-prb',
          },
          {
            name: 'Manage Resep Apotek BPJS',
            link: '/apotek-bpjs/manage-resep',
          },
        ],
      },
      {
        name: 'PCare',
        icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
        link: '/pcare',
        children: [
          {
            name: 'Diagnosa',
            link: '/pcare/diagnosa',
          },
          {
            name: 'Dokter',
            link: '/pcare/dokter',
          },
          {
            name: 'Kelompok',
            link: '/pcare/kelompok',
          },
          {
            name: 'Kesadaran',
            link: '/pcare/kesadaran',
          },
          {
            name: 'Kunjungan',
            link: '/pcare/kunjungan',
          },
          {
            name: 'MCU',
            link: '/pcare/mcu',
          },
          {
            name: 'Obat',
            link: '/pcare/obat',
          },
          {
            name: 'Pendaftaran',
            link: '/pcare/pendaftaran',
          },
          {
            name: 'Peserta',
            link: '/pcare/peserta',
          },
          {
            name: 'Poli',
            link: '/pcare/poli',
          },
          {
            name: 'Provider',
            link: '/pcare/provider',
          },
          {
            name: 'Spesialis',
            link: '/pcare/spesialis',
          },
          {
            name: 'Status Pulang',
            link: '/pcare/status-pulang',
          },
          {
            name: 'Tindakan',
            link: '/pcare/tindakan',
          },
          {
            name: 'Manage Kunjungan',
            link: '/pcare/manage-kunjungan-pcare',
          },
          {
            name: 'Manage Pendaftaran',
            link: '/pcare/manage-pendaftaran',
          },
          {
            name: 'Manage Tindakan',
            link: '/pcare/manage-tindakan',
          },
          {
            name: 'Manage Obat',
            link: '/pcare/manage-obat',
          },
          {
            name: 'Manage MCU',
            link: '/pcare/manage-mcu',
          },
        ],
      },
      {
        name: 'Vclaim',
        icon: './assets/media/svg/icons/Periksa/integrasi-icon.svg',
        link: '/vclaim',
        children: [
          {
            name: 'Referensi',
            link: '/vclaim/referensi',
          },
          {
            name: 'Peserta',
            link: '/vclaim/peserta',
          },
          {
            name: 'SEP',
            link: '/vclaim/sep',
          },
          {
            name: 'Rujukan',
            link: '/vclaim/rujukan',
          },
          {
            name: 'Rujuk Balik (PRB)',
            link: '/vclaim/rujuk-balik',
          },
          {
            name: 'Rujuk Khusus',
            link: '/vclaim/rujukan-khusus',
          },
          {
            name: 'Monitoring',
            link: '/vclaim/monitoring',
          },
          {
            name: 'Rencana Kontrol',
            link: '/vclaim/rencana-kontrol',
          },
          {
            name: 'Lembar Pengajuan Klaim',
            link: '/vclaim/lembar-pengajuan-klaim',
          },
          {
            name: 'Manage SEP',
            link: '/vclaim/manage-sep',
          },
          {
            name: 'Manage Rujukan',
            link: '/vclaim/manage-rujukan',
          },
          {
            name: 'Manage Rencana Kontrol',
            link: '/vclaim/manage-rencana-kontrol',
          },
          {
            name: 'Manage Pengajuan SEP',
            link: '/vclaim/manage-pengajuan-sep',
          },
          {
            name: 'Manage Approval Pengajuan SEP',
            link: '/vclaim/manage-approval-pengajuan-sep',
          },
          {
            name: 'Manage Tanggal Pulang SEP',
            link: '/vclaim/manage-update-tanggal-sep',
          },
          {
            name: 'Manage Rujuk Balik',
            link: '/vclaim/manage-rujuk-balik',
          },
          {
            name: 'Manage Rujuk Khusus',
            link: '/vclaim/manage-rujuk-khusus',
          },
          {
            name: 'Manage Lembar Pengajuan Klaim',
            link: '/vclaim/manage-lpk',
          },
          {
            name: 'Monitoring Latency BPJS',
            link: '/vclaim/monitoring-latency-bpjs',
          },
        ],
      },
      {
        name: 'Antrian WS BPJS',
        icon: './assets/media/svg/icons/Periksa/integrasi-icon.svg',
        link: '/antrian-ws-bpjs',
        children: [
          {
            name: 'Referensi Poli',
            link: '/antrian-ws-bpjs/referensi-poli',
          },
          {
            name: 'Referensi Poli (PCARE)',
            link: '/antrian-ws-bpjs/referensi-poli-pcare',
          },
          {
            name: 'Referensi Dokter',
            link: '/antrian-ws-bpjs/referensi-dokter',
          },
          {
            name: 'Referensi Dokter (PCARE)',
            link: '/antrian-ws-bpjs/referensi-dokter-pcare',
          },
          {
            name: 'Referensi Poli Finger Print',
            link: '/antrian-ws-bpjs/referensi-poli-finger-print',
          },
          {
            name: 'Referensi Jadwal Dokter',
            link: '/antrian-ws-bpjs/referensi-jadwal-dokter',
          },
          {
            name: 'Dashboard Per Tanggal',
            link: '/antrian-ws-bpjs/dashboard-per-tanggal',
          },
          {
            name: 'Dashboard Per Bulan',
            link: '/antrian-ws-bpjs/dashboard-per-bulan',
          },
          {
            name: 'Antrean Per Tanggal',
            link: '/antrian-ws-bpjs/antrean-per-tanggal',
          },
          {
            name: 'Antrean Per Kode Booking',
            link: '/antrian-ws-bpjs/antrean-per-kode-booking',
          },
          {
            name: 'Antrean Per Jadwal Dokter',
            link: '/antrian-ws-bpjs/antrean-per-jadwal-dokter',
          },
          {
            name: 'Antrean Belum Dilayani',
            link: '/antrian-ws-bpjs/antrean-belum-dilayani',
          },
          {
            name: 'Manage Antrian BPJS',
            link: '/antrian-ws-bpjs/manage-antrian-bpjs',
          },
          {
            name: 'Manage Antrian BPJS (PCARE)',
            link: '/antrian-ws-bpjs/manage-antrian-bpjs-pcare',
          },
        ],
      },
      {
        name: 'RS Online',
        icon: './assets/media/svg/icons/Periksa/integrasi-icon.svg',
        link: '/rs-online',
        children: [
          {
            name: 'Laporan Covid',
            link: '/rs-online/laporan-covid',
          },
          {
            name: 'Rekap Pasien Masuk',
            link: '/rs-online/manage-rekap-pasien-masuk',
          },
          {
            name: 'Rekap Pasien Dirawat',
            link: '/rs-online/manage-rekap-pasien-dirawat',
          },
          {
            name: 'Rekap Pasien Keluar',
            link: '/rs-online/manage-rekap-pasien-keluar',
          },
          {
            name: 'Manage Tempat Tidur',
            link: '/rs-online/manage-tempat-tidur',
          },
          {
            name: 'Manage SDM',
            link: '/rs-online/manage-sdm',
          },
          {
            name: 'Manage APD',
            link: '/rs-online/manage-apd',
          },
          {
            name: 'Manage PCR Nakes',
            link: '/rs-online/manage-pcr-nakes',
          },
          {
            name: 'Manage Nakes Terinfeksi',
            link: '/rs-online/manage-nakes-terinfeksi',
          },
          {
            name: 'Manage Oksigen',
            link: '/rs-online/manage-oksigen',
          },
          {
            name: 'Manage SHK',
            link: '/rs-online/manage-shk',
          },
          {
            name: 'Manage Hasil SHK',
            link: '/rs-online/manage-hasil-shk',
          },
        ],
      },
      // {
      //   name: 'Bridging BPJS',
      //   icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
      //   single: true,
      //   link: '/software-setting/setting-menu/bpjs',
      // },p
      // {
      //   name: 'Bridging SIKARS',
      //   icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
      //   single: true,
      //   link: '/software-setting/setting-menu/sikars',
      // },
      // {
      //   name: 'Bridging Siranap',
      //   icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
      //   single: true,
      //   link: '/software-setting/setting-menu/siranap',
      // },
      // {
      //   name: 'Bridging Sisrute',
      //   icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
      //   single: true,
      //   link: '/software-setting/setting-menu/sisrute',
      // },
      // {
      //   name: 'Bridging Yankes',
      //   icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
      //   single: true,
      //   link: '/software-setting/setting-menu/yankes',
      // },
      {
        name: 'Cron Jobs',
        icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
        single: true,
        link: '/software-setting/setting-menu/cron-jobs',
      },
      {
        name: 'Bot Message Templates',
        icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
        single: true,
        link: '/software-setting/setting-menu/bot-message-templates',
      },
    ],
  },
  {
    name: 'Master Data',
    groupChildren: [
      {
        name: 'Software Setting',
        icon: './assets/media/svg/icons/Periksa/setting-icon.svg',
        link: '/software-setting',
        children: [
          {
            name: `Master Login dan User`,
            link: '/software-setting/master-login',
          },
          {
            name: 'Master Loket Antrian',
            link: '/software-setting/master-loket-antrian',
          },
          {
            name: 'Master Loket Panggilan',
            link: '/software-setting/master-loket-panggilan',
          },
          {
            name: 'Master Jenis Loket',
            link: '/software-setting/master-jenis-loket',
          },
          {
            name: 'Setting',
            link: '/software-setting/setting-menu/data-klinik/info',
          },
        ],
      },

      {
        name: 'Master E-Office',
        icon: './assets/media/svg/icons/Periksa/master-e-office-icon.svg',
        link: '/e-office',
        children: [
          {
            name: 'Kategori E-Office',
            link: '/e-office/kategori-eoffice',
          },
          {
            name: 'Manage Jenis File',
            link: '/e-office/jenis-file',
          },
        ],
      },
      {
        name: 'Master Farmasi',
        icon: './assets/media/svg/icons/Periksa/master-farmasi-icon.svg',
        link: '/master-farmasi',
        children: [
          {
            name: 'Manage Waktu Minum',
            link: '/master-farmasi/manage-waktu-minum',
          },
          {
            name: 'Manage Signa',
            link: '/master-farmasi/manage-signa',
          },
          {
            name: 'Manage Cara Pakai',
            link: '/master-farmasi/manage-cara-pakai',
          },
          {
            name: 'Manage Kemasan',
            link: '/master-farmasi/manage-kemasan',
          },
          {
            name: 'Master Ingredient',
            link: '/master-farmasi/master-ingredient',
          },
          {
            name: 'Master Paket Obat',
            link: '/master-farmasi/manage-paket-obat',
          },
          {
            name: 'Manage Keyword Obat',
            link: '/master-farmasi/manage-keyword-obat',
          },
          {
            name: 'Manage Keyword Obat by Personal',
            link: '/master-farmasi/keyword-obat-personal',
          },
          {
            name: 'Setting RCOST',
            link: '/master-farmasi/setting-rcost',
          },
          {
            name: 'Setting RCOST Non Racikan',
            link: '/master-farmasi/setting-rcost-non-racikan',
          },
          {
            name: 'Setting RCOST Racikan',
            link: '/master-farmasi/setting-rcost-racikan',
          },
          {
            name: 'Verifikasi Resep',
            link: '/master-farmasi/verifikasi-resep',
          },
          {
            name: 'Telaah Resep',
            link: '/master-farmasi/telaah-obat',
          },
        ],
      },
      {
        name: 'Master Gaji Karyawan',
        icon: './assets/media/svg/icons/Periksa/master-gaji-karyawan.svg',
        link: '/gaji-karyawan',
        children: [
          {
            name: 'Manage Indikator Gaji',
            link: '/gaji-karyawan/indikator-gaji',
          },
          {
            name: 'Manage Indikator Potongan Gaji',
            link: '/gaji-karyawan/indikator-potong-gaji',
          },
          {
            name: 'Setting Gaji',
            link: '/gaji-karyawan/setting-gaji',
          },
          {
            name: 'Manage Gaji Pegawai',
            link: '/gaji-karyawan/manage-gaji-karyawan',
          },
        ],
      },
      {
        name: 'Master Gizi',
        icon: './assets/media/svg/icons/Periksa/gizi-icon.svg',
        link: '/master-gizi',
        children: [
          {
            name: 'Bentuk Makanan Gizi',
            link: '/master-gizi/bentuk-makanan-gizi',
          },
          {
            name: 'Tipe Diet Gizi',
            link: '/master-gizi/tipe-diet-gizi',
          },
          {
            name: 'Jenis Diet Gizi',
            link: '/master-gizi/jenis-diet-gizi',
          },
        ],
      },
      {
        name: 'Master Keuangan',
        icon: './assets/media/svg/icons/Periksa/master-keuangan-icon.svg',
        link: '/master-keuangan',
        children: [
          {
            name: 'Manage Metode Pembayaran',
            link: '/master-keuangan/manage-metode-pembayaran',
          },
          {
            name: 'Kelompok Tindakan',
            link: '/master-keuangan/kelompok-tindakan',
          },
          {
            name: 'Jenis Tindakan',
            link: '/master-keuangan/kategori-tindakan',
          },
          {
            name: 'Pengelompokan Sistem',
            link: '/master-keuangan/pengelompokan-sistem',
          },
          {
            name: 'Rumus',
            link: '/master-keuangan/rumus',
          },
          {
            name: 'Indikator Jasa Pelayanan',
            link: '/master-keuangan/indikator-jasa-pelayanan',
          },
          {
            name: 'Jasa Operasi',
            link: '/master-keuangan/jasa-operasi',
          },
          {
            name: 'Manage Biaya Tambahan Kasir',
            link: '/software-setting/manage-biaya-tambahan-kasir',
          },
        ],
      },
      {
        name: 'Master Klinik',
        icon: './assets/media/svg/icons/Periksa/master-klinik-icon.svg',
        link: '/master-klinik',
        children: [
          {
            name: 'Build Form',
            link: '/akreditasi/manage-build-form',
          },
          {
            name: 'Farmakologi',
            link: '/master-klinik/farmakologi',
          },
          {
            name: 'PPN',
            link: '/master-klinik/ppn',
          },
          {
            name: 'Instalasi',
            link: '/master-klinik/instalasi',
          },
          {
            name: 'Poli Klinik',
            link: '/master-klinik/poli-klinik',
          },
          {
            name: 'Public Holiday',
            link: '/master-klinik/public-holiday',
          },
          {
            name: 'Quotes',
            link: '/master-klinik/quotes',
          },
          {
            name: 'Company Holiday',
            link: '/master-klinik/company-holiday',
          },
          {
            name: 'Manage Panduan Pengguna',
            link: '/master-klinik/manage-panduan-pengguna',
          },
          {
            name: 'Cabang',
            link: '/master-klinik/cabang',
          },
          {
            name: 'Group Tindakan',
            link: '/master-klinik/group-tindakan',
          },
          {
            name: 'Bank',
            link: '/master-klinik/bank',
          },
          {
            name: 'Jasa Pengiriman',
            link: '/master-klinik/jasa-pengiriman',
          },
          {
            name: 'Marketplace',
            link: '/master-klinik/marketplace',
          },
          {
            name: 'Ruang Inap',
            link: '/master-klinik/ruang-inap',
          },
          {
            name: 'Group Rawat Inap',
            link: '/master-klinik/group-rawat-inap',
          },
          {
            name: 'Daftar Kelas Inap',
            link: '/master-klinik/daftar-kelas-inap',
          },
          {
            name: 'Ruang Non Medis',
            link: '/master-klinik/ruang-non-medis',
          },
          {
            name: 'Tarif Rawat Inap',
            link: '/master-klinik/tarif-rawat-inap',
          },
          {
            name: 'Tarif Rawat Jalan',
            link: '/master-klinik/tarif-rawat-jalan',
          },
          {
            name: 'Asuransi',
            link: '/master-klinik/asuransi',
          },
          {
            name: 'Jenis BPJS',
            link: '/master-klinik/jenis-bpjs',
          },

          {
            name: 'Event',
            link: '/master-klinik/event',
          },
          {
            name: 'Banner',
            link: '/master-klinik/banner',
          },
          {
            name: 'Satuan',
            link: '/master-klinik/satuan',
          },
          {
            name: 'Cuti Disable',
            link: '/master-klinik/cuti-disable',
          },
          {
            name: 'Master Perujuk',
            link: '/master-klinik/perujuk',
          },
          {
            name: 'Master Social Media',
            link: '/master-klinik/social-media',
          },
          {
            name: 'Master Perpustakaan',
            link: '/master-klinik/perpustakaan',
          },
          {
            name: 'Master Subscription',
            link: '/master-klinik/subscriptions-package',
          },
          {
            name: 'Master Tantangan',
            link: '/master-klinik/tantangan',
          },
          {
            name: 'Master Voucher',
            link: '/master-klinik/voucher',
          },
          {
            name: 'Template Broadcast Whatsapp',
            link: '/master-klinik/master-broadcast-whatsapp',
          },
          {
            name: 'Master Quick Reply',
            link: '/master-klinik/master-quick-reply',
          },
          {
            name: 'Kategori Game',
            link: '/master-klinik/kategori-game',
          },
          {
            name: 'Game',
            link: '/master-klinik/game',
          },
          {
            name: 'Jenis Laundry',
            link: '/master-klinik/jenis-laundry',
          },
          {
            name: 'Jenis Ruang',
            link: '/master-klinik/jenis-ruang',
          },
        ],
      },
      {
        name: 'Master Penunjang',
        icon: './assets/media/svg/icons/Periksa/master-lab-icon.svg',
        link: '/master-laboratorium',
        children: [
          {
            name: 'Manage Tindakan Laboratorium',
            link: '/master-laboratorium/manage-tindakan-laboratorium',
          },
          {
            name: 'Manage Tindakan Radiologi',
            link: '/master-laboratorium/manage-tindakan-radiologi',
          },
          {
            name: 'Manage Kategori Cek',
            link: '/master-laboratorium/manage-kategori-cek',
          },
          {
            name: 'Manage Group Laboratorium',
            link: '/master-laboratorium/manage-group-laboratorium',
          },
          {
            name: 'Manage Ukuran Film',
            link: '/master-laboratorium/manage-ukuran-film',
          },
          {
            name: 'Manage Tindakan Mikrobiologi',
            link: '/master-laboratorium/manage-tindakan-mikrobiologi',
          },
          {
            name: 'Manage Jenis Spesimen',
            link: '/master-laboratorium/manage-jenis-spesimen',
          },
          {
            name: 'Manage Tindakan Patologi',
            link: '/master-laboratorium/manage-tindakan-patologi',
          },
          {
            name: 'Manage Paket MCU',
            link: '/master-laboratorium/manage-paket-mcu',
          },
          {
            name: 'Manage Tindakan UTD',
            link: '/master-laboratorium/manage-tindakan-utd',
          },
        ],
      },
      {
        name: 'Master Logistik',
        icon: './assets/media/svg/icons/Periksa/master-logistik-icon.svg',
        link: '/master-logistik',
        children: [
          {
            name: 'Approval',
            link: '/master-logistik/approval',
          },
          {
            name: 'Data Bill To',
            link: '/master-logistik/data-bill-to',
          },
          {
            name: 'Group Barang',
            link: '/master-logistik/group-barang',
          },
          {
            name: 'Gudang',
            link: '/master-logistik/gudang',
          },
          {
            name: 'Jenis Gudang',
            link: '/master-logistik/jenis-gudang',
          },
          {
            name: 'Master Jenis Pemakaian Barang',
            link: '/master-logistik/jenis-pemakaian-barang',
          },
          {
            name: 'Kategori Barang',
            link: '/master-logistik/kategori-barang',
          },
          {
            name: 'Principal',
            link: '/master-logistik/principal',
          },
          {
            name: 'Rak Gudang',
            link: '/master-logistik/rak-gudang',
          },
          {
            name: 'Keyword Permintaan',
            link: '/master-logistik/keyword-permintaan',
          },
        ],
      },
      {
        name: 'Master Medis',
        icon: './assets/media/svg/icons/Periksa/master-medis-icon.svg',
        link: '/master-medis',
        children: [
          {
            name: 'Parameter Tindakan',
            link: '/master-medis/parameter-tindakan',
          },
          {
            name: 'Master Jenis Pelayanan',
            link: '/master-medis/master-jenis-pelayanan',
          },
          {
            name: 'Pertanyaan PPK',
            link: '/master-medis/pertanyaan-ppk',
          },
          {
            name: 'Group PPK',
            link: '/master-medis/group-ppk',
          },
          {
            name: 'Master Clinical Pathway',
            link: '/master-medis/master-clinical-pathway',
          },
          // {
          //   name: 'Pertanyaan Tindakan',
          //   link: '/master-medis/pertanyaan-tindakan',
          // },
          {
            name: 'Ruang Operasi',
            link: '/master-medis/ruang-operasi',
          },
          {
            name: 'Jenis Darah',
            link: '/master-medis/jenis-darah',
          },
          {
            name: 'Jenis Pemeriksaan',
            link: '/master-medis/jenis-pemeriksaan',
          },
          {
            name: 'Manage Formulir Medis',
            link: '/formulir/form-medis',
          },
          {
            name: 'Manage Surat Keterangan',
            link: '/formulir/surat-keterangan',
          },
          {
            name: 'Manage Imunisasi',
            link: '/master-medis/imunisasi',
          },
          {
            name: 'Manage Alasan Imunisasi',
            link: '/master-medis/reason-imunisasi',
          },
          {
            name: 'Manage Rute Imunisasi',
            link: '/master-medis/rute-imunisasi',
          },
          {
            name: 'Manage Tarif Odontogram',
            link: '/master-medis/tarif-odontogram',
          },
          {
            name: 'Manage Bahan Dan Jenis Fiksasi Patologi',
            link: '/medis/manage-bahan-jenis-fiksasi-patologi',
          },
          {
            name: 'Master GCS',
            link: '/master-medis/master-gcs',
          },
          {
            name: 'Master Jenis Operasi',
            link: '/master-medis/master-jenis-operasi',
          },
          {
            name: 'Master LOINC',
            link: '/master-medis/master-loinc',
          },
          {
            name: 'Master Alergi',
            link: '/master-medis/master-alergi',
          },
          {
            name: 'Master EWS',
            link: '/master-medis/master-ews',
          },
        ],
      },
      {
        name: 'Master Pasien',
        icon: './assets/media/svg/icons/Periksa/master-pasien-icon.svg',
        link: '/master-pasien',
        children: [
          {
            name: 'Agama',
            link: '/master-pasien/agama',
          },
          {
            name: 'Golongan Darah',
            link: '/master-pasien/golongan-darah',
          },
          {
            name: 'Negara',
            link: '/master-pasien/negara',
          },
          {
            name: 'Provinsi',
            link: '/master-pasien/provinsi',
          },
          {
            name: 'Kota/Kabupaten',
            link: '/master-pasien/kota-kabupaten',
          },
          {
            name: 'Kecamatan',
            link: '/master-pasien/kecamatan',
          },
          {
            name: 'Testimoni',
            link: '/master-pasien/testimoni',
          },
          {
            name: 'Kelurahan',
            link: '/master-pasien/kelurahan',
          },
          {
            name: 'Suku',
            link: '/master-pasien/suku',
          },
          {
            name: 'Reference Pekerjaan',
            link: '/master-pasien/reference-pekerjaan',
          },

          {
            name: 'Reference Hubungan',
            link: '/master-pasien/reference-hubungan',
          },
          {
            name: 'Pendidikan',
            link: '/master-pasien/pendidikan',
          },

          {
            name: 'Penjamin',
            link: '/master-pasien/nasabah',
          },

          {
            name: 'Pengirim',
            link: '/master-pasien/pengirim',
          },
          {
            name: 'Jabatan Pasien',
            link: '/master-pasien/jabatan',
          },
          {
            name: 'Identifikasi Khusus',
            link: '/master-pasien/identifikasi-khusus',
          },
          {
            name: 'Kategori Pasien',
            link: '/medical-record/master-kategori-pasien',
          },
          {
            name: 'Penyakit Menular',
            link: '/master-pasien/penyakit-menular',
          },
        ],
      },
      {
        name: 'Managemen Pendidikan',
        icon: './assets/media/svg/icons/Periksa/master-pendidikan-icon.svg',
        link: '/managemen-pendidikan',
        children: [
          {
            name: 'Manage Mahasiswa',
            link: '/managemen-pendidikan/manage-mahasiswa',
          },
          {
            name: 'Manage Kompetensi',
            link: '/managemen-pendidikan/manage-kompetensi',
          },
          {
            name: 'Kelompok dan Jadwal Kelompok Mahasiswa',
            link: '/managemen-pendidikan/jadwal-kelompok-mahasiswa',
          },
          {
            name: 'Penilaian',
            link: '/managemen-pendidikan/penilaian',
          },
          {
            name: 'Penilaian Komkordik',
            link: '/managemen-pendidikan/penilaian-komkordik',
          },
          {
            name: 'Manage Jam Kerja Mahasiswa',
            link: '/managemen-pendidikan/jam-kerja-mahasiswa',
          },
        ],
      },
      {
        name: 'Pendidikan',
        icon: './assets/media/svg/icons/Periksa/master-pendidikan-icon.svg',
        link: '/pendidikan',
        children: [
          {
            name: 'Jadwal Kelompok',
            link: '/pendidikan/jadwal-kelompok',
          },
          {
            name: 'Nilai',
            link: '/pendidikan/nilai',
          },
          {
            name: 'Perawatan',
            link: '/pendidikan/perawatan',
          },
        ],
      },
      {
        name: 'Master Pendidikan',
        icon: './assets/media/svg/icons/Periksa/master-pendidikan-icon.svg',
        link: '/master-pendidikan',
        children: [
          {
            name: 'Master Kasus',
            link: '/master-pendidikan/master-kasus',
          },
          {
            name: 'Master Institusi',
            link: '/master-pendidikan/master-institusi',
          },
          {
            name: 'Master Spesialis',
            link: '/master-pendidikan/master-spesialis',
          },
          {
            name: 'Master Jenis Pendidikan',
            link: '/master-pendidikan/master-jenis-pendidikan',
          },
          {
            name: 'Master Requirement Penilaian',
            link: '/master-pendidikan/master-requirement-penilaian',
          },
          {
            name: 'Master Angkatan Kompetensi',
            link: '/master-pendidikan/master-angkatan-kompetensi',
          },
          {
            name: 'Master Stase',
            link: '/master-pendidikan/master-stase',
          },
          {
            name: 'Master Angkatan',
            link: '/master-pendidikan/master-angkatan',
          },
        ],
      },
      {
        name: 'Master User',
        icon: './assets/media/svg/icons/Periksa/master-user-icon.svg',
        link: '/master-user',
        children: [
          {
            name: 'Navigasi',
            link: '/master-user/navigasi',
          },
          {
            name: 'Cuti',
            link: '/master-user/cuti',
          },
          {
            name: 'Kategori Karyawan',
            link: '/master-user/kategori-karyawan',
          },
          {
            name: 'Direktorat',
            link: '/master-user/direktorat',
          },
          {
            name: 'Satuan Organisasi',
            link: '/master-user/satuan-organisasi',
          },
          {
            name: 'Golongan Jabatan',
            link: '/master-user/golongan-jabatan',
          },

          {
            name: 'Jabatan',
            link: '/master-user/jabatan',
          },
          {
            name: 'Jenis Kepegawaian',
            link: '/master-user/jenis-kepegawaian',
          },
          {
            name: 'Jenis Pekerjaan',
            link: '/master-user/jenis-pekerjaan',
          },
          {
            name: 'Spesialis',
            link: '/master-user/spesialis',
          },
          {
            name: 'Profesi',
            link: '/master-user/profesi',
          },
          {
            name: 'Unit Kerja',
            link: '/master-user/unit-kerja',
          },
          {
            name: 'Pelatihan',
            link: '/master-user/pelatihan',
          },
          {
            name: 'Fasilitas',
            link: '/master-user/fasilitas',
          },
          {
            name: 'Sanksi',
            link: '/master-user/sanksi',
          },
          {
            name: 'Status Kepegawaian',
            link: '/master-user/status-kepegawaian',
          },
        ],
      },
    ],
  },
];
